var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"title":'Movimientos de Stock de '+_vm.article.name+' | N° '+_vm.article.id,"hide-footer":"","size":"lg","id":"stock-movement-modal-info"}},[_c('nav-component'),_c('table-component')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }